import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";

export function InvitationAuthBlock() {
  const { opaque_token } = useParams<{ opaque_token: string }>();
  const redirectTo = `/invitations/${opaque_token}`;

  return (
    <div className="w-screen h-dvh min-h-dvh flex flex-col items-center justify-center">
      <div className="w-screen max-w-lg max-lg:max-w-screen-lg flex flex-col p-4 items-center">
        <div className="mb-2">
          <img src="/logo.svg" width="128" alt="Logo" />
        </div>
        <div className="mb-2">
          <span className="font-medium text-xl">
            Приглашение в Elasticspace
          </span>
        </div>
        <div className="mb-4 text-center">
          <span>
            Для принятия приглашения Вам необходимо авторизоваться в системе.
          </span>
        </div>
        <div className="flex flex-col gap-2 justify-self-end w-full">
          <Button
            as={Link}
            href={`/auth/login?redirect_to=${encodeURIComponent(redirectTo)}`}
            color="primary">
            Войти
          </Button>
          <Button
            as={Link}
            href={`/auth/register?redirect_to=${encodeURIComponent(redirectTo)}`}
            color="primary"
            variant="flat">
            Зарегистрироваться
          </Button>
        </div>
      </div>
    </div>
  );
}
